// extracted by mini-css-extract-plugin
module.exports = {"container":"week-module--container--2N5cd"};